import PushStateNavigationEngine from 'rlink-router/PushStateNavigationEngine';
import pathForRouteInfo from 'rlink-router/pathForRouteInfo';
import routeInfoForPath from 'rlink-router/routeInfoForPath';
import NoopNavigationEngine from 'rlink-router/NoopNavigationEngine';
import { HASH } from 'rlink-router/constants';
import QueryString from 'rlink-querystring';

function rlinkInitPageState () {
  let initPageAttr = document
    .querySelector('[data-rlink-init-page]')
    .getAttribute('data-rlink-init-page');

  if (initPageAttr) {
    let initialState = JSON.parse(initPageAttr);
    let params = QueryString.combineSearchAndHash();
    if (Object.keys(params).length === 0) {
      params = { [HASH]: window.location.hash };
    }

    return Object.assign(initialState, {
      params: Object.assign(initialState.params, params),
    });
  }
}

export default function navigationEngineFromStore (store, initialState = rlinkInitPageState) {
  if (typeof document === 'undefined') {
    return new NoopNavigationEngine();
  } else {
    return new PushStateNavigationEngine({
      getUrlFromState: ({view, params}) => pathForRouteInfo(store.getState().routing, view, params),
      getStateFromUrl: url => routeInfoForPath(store.getState().routing, url),
      initialState: typeof initialState === 'function' ? initialState() : initialState,
    });
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-router/navigationEngineFromStore.js